// extracted by mini-css-extract-plugin
module.exports = {"alignRight":"Pill_alignRight__5KbmT","alignLeft":"Pill_alignLeft__OfnZv"};